var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:[_vm.className, _vm.$style.icon, _vm.small ? _vm.$style.small : ''],attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.iconPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }